/**
 * Message Cleanup Utilities
 * Pure functions for managing chat message cleanup
 */

import type { Dispatch } from '@reduxjs/toolkit';

import { removeMessagesBetweenSteps } from '../data-store/copilotSlice';

/**
 * Remove messages between current step and next step
 * This removes responses, helpers, and transitions after the edited step
 */
const cleanupStepMessages = (
  dispatch: Dispatch,
  currentStepName: string
): void => {
  dispatch(removeMessagesBetweenSteps({ currentStepName }));
};

export default cleanupStepMessages;
